<template>
	<div class="buildingQueue">
		<div class="centerArea unselectable">
			<div
				class="destructionQueueContainer queueContainer destructionQueueDragOut"
				v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_DESTRUCTION].length > 0"
			>
				<div
					class="buildingQueueSlot entityBox noActive"
					@mouseleave="onHideDetails()"
					@mouseover="onShowDetails(BuildingQueue.TYPE_DESTRUCTION, 0)"
				>
					<div
						class="buildingSlotImage buildingMini"
						:class="[
							'tribeId1',
							'level'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_DESTRUCTION][0].lvl,
							'buildingType'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_DESTRUCTION][0].buildingType
						]"
					>
						<div class="levelBubble">{{gameModel.buildingQueue.queues[BuildingQueue.TYPE_DESTRUCTION][0].lvl}}</div>
					</div>
					<div class="progressbar">
						<div class="progress">
							<div class="bar negative perc" style="z-index: 2;" :style="{width: buildPercentage(BuildingQueue.TYPE_DESTRUCTION)+'%'}"></div>
							<div class="bar additionalBar additionalPerc"></div>
							<div class="marker">
								<div class="markerInner"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="buildingQueueContainer queueContainer buildingQueueDragOut">
				<div class="constructionContainer">
					<div
						class="buildingQueueSlot entityBox noActive"
						:class="{
							hover: gameModel.buildingQueue.activeSlot == BuildingQueue.TYPE_BUILD,
							paid: gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD].length > 0,
						}"
						@mouseleave="onHideDetails()"
						@mouseover="onShowDetails(BuildingQueue.TYPE_BUILD, 0)"
					>
						<i
							v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD].length == 0"
							class="slotIcon boxIcon builderIcon feature_buildingqueue_slot_combine_medium_flat_black"
							:class="[
								'queueType'+BuildingQueue.TYPE_BUILD,
								{
									//'feature_buildingqueue_slot_combine_medium_flat_black': gameModel.buildingQueue.largeSlot,
									//'feature_buildingqueue_slot_village_medium_flat_black': !gameModel.buildingQueue.largeSlot && queueType == BuildingQueue.TYPE_BUILD,
									//'feature_buildingqueue_slot_fields_medium_flat_black': !gameModel.buildingQueue.largeSlot && queueType == BuildingQueue.TYPE_RESOURCES,
								}
							]"
						></i>
						<div
							v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD].length > 0"
							class="buildingSlotImage buildingMini"
							:class="[
								'tribeId1',
								'slot0',
								'buildingType'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD][0].buildingType,
								'level'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD][0].lvl,
								'queueType'+BuildingQueue.TYPE_BUILD,
								{
									paid: gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD][0].length > 0,
								}
							]"
						>
							<div
								class="levelBubble"
								:class="{
									enoughResources: gameModel.island.storage.hasEnoughResources(gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD][0].cost)
								}"
							>{{gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD][0].lvl}}</div>
						</div>
						<div
							v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD].length > 0"
							class="progressbar"
						>
							<div class="progress">
								<div class="bar positive perc" style="z-index: 2;" :style="{width: buildPercentage(BuildingQueue.TYPE_BUILD)+'%'}"></div>
								<div class="bar additionalBar additionalPerc"></div>
								<div class="marker">
									<div class="markerInner"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="buildQueueContainer">
					<div
						v-for="slotNr in range(1, BuildingQueue.BUILD_QUEUE_SLOTS)"
						class="buildingQueueSlot entityBox noActive"
						:class="[
							'slot'+slotNr,
							{
								hover: (gameModel.buildingQueue.activeSlot.slotHover == BuildingQueue.TYPE_BUILD_QUEUE || gameModel.buildingQueue.activeSlot.detailHover == BuildingQueue.TYPE_BUILD_QUEUE) && (gameModel.buildingQueue.activeSlot.slot == slotNr || gameModel.buildingQueue.activeSlot.slotDetail == slotNr),
								paid: gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1] && gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].paid,
								locked: gameModel.buildingQueue.availableBuildQueueSlots < slotNr,
								empty: gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE].length < slotNr,
							}
						]"
						@mouseleave="onHideDetails()"
						@mouseover="onShowDetails(BuildingQueue.TYPE_BUILD_QUEUE, slotNr)"
					>
						<div v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE].length < slotNr && gameModel.buildingQueue.availableBuildQueueSlots >= slotNr">
							<div class="topLeftBorder"></div>
							<div class="bottomRightBorder"></div>
							<i class="slotIcon builderIcon feature_buildqueue_small_flat_black"></i>
						</div>
						<i v-if="gameModel.buildingQueue.availableBuildQueueSlots < slotNr" class="slotIcon lockedState symbol_lock_small_flat_black"></i>
						<div
							v-if="gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1]"
							class="buildingSlotImage buildingMini"
							:class="[
								'tribeId1',
								'slot'+slotNr,
								'buildingType'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].buildingType,
								'level'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].lvl,
								'queueType'+gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].queueType,
								{
									paid: gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1] && gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].paid,
								}
							]"
						>
							<div
								class="levelBubble"
								:class="{
									enoughResources: gameModel.island.storage.hasEnoughResources(gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].cost)
								}"
							>{{gameModel.buildingQueue.queues[BuildingQueue.TYPE_BUILD_QUEUE][slotNr - 1].lvl}}</div>
						</div>
					</div>
				</div>
			</div>
			<building-queue-details />
		</div>
	</div>
</template>

<style lang="scss">
.buildingQueue {
	position: fixed;
	left: 0;
	bottom: 82px;
	width: calc(50% - -161px);
	min-width: 660px;
	text-align: center;
	z-index: 1;

	&:hover {
		z-index: 3000;
	}

	.centerArea {
		position: absolute;
		right: 0;
		width: 277px;
	}

	.queueContainer {
		background-color: rgba(235, 235, 235, 0.65);
		border: 1px solid #fff;
		-webkit-box-shadow: 0 0 1px 1px rgba(136, 136, 136, 0.75);
		-moz-box-shadow: 0 0 1px 1px rgba(136, 136, 136, 0.75);
		box-shadow: 0 0 1px 1px rgba(136, 136, 136, 0.75);
	}

	.buildingQueueContainer {
		position: relative;
		margin: auto;
		height: 55px;
		width: 100%;

		.constructionContainer {
			position: relative;
			height: 43px;
			width: 65px;
			margin: 5px;
			border: 1px solid #b8b2a9;
			background-color: rgba(241, 240, 238, 0.5);
			text-align: left;

			> i {
				position: relative;
				top: 6px;
				left: 40px;
				filter: alpha(opacity = 40);
				opacity: 0.4;
			}

			.buildingQueueSlot {
				float: left;
				margin: (-1px) 4px -1px -1px;

				border-right: none !important;

				i.slotIcon {
					left: -1px;
					top: 6px;
					filter: alpha(opacity = 40);
					opacity: 0.4;
				}

				&:before {
					content: '';
					position: absolute;
					top: 0;
					right: -1px;
					height: 100%;
					width: 1px;
					background-image: -owg-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
					background-image: -webkit-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
					background-image: -moz-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
					background-image: -o-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
					background-image: linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
				}

				&:after {
					content: '';
					position: absolute;
					top: 0;
					right: 0;
					height: 100%;
					width: 1px;
					background-image: -owg-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
					background-image: -webkit-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
					background-image: -moz-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
					background-image: -o-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
					background-image: linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
				}

				&:hover:before, &.hover:before {
					background-image: -owg-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
					background-image: -webkit-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
					background-image: -moz-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
					background-image: -o-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
					background-image: linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
				}

				&:hover:after, &.hover:after {
					background-image: -owg-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
					background-image: -webkit-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
					background-image: -moz-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
					background-image: -o-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
					background-image: linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
				}

				~ .buildingQueueSlot {
					border-right: 1px solid #b8b2a9;
					border-left: none !important;

					&:before {
						content: '';
						position: absolute;
						top: 0;
						left: -1px;
						height: 100%;
						width: 1px;
						background-image: -owg-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
						background-image: -webkit-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
						background-image: -moz-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
						background-image: -o-linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
						background-image: linear-gradient(to top, #b8b2a9 9px, transparent 9px, transparent 13px, #b8b2a9 13px, #b8b2a9 20px, transparent 20px, transparent 24px, #b8b2a9 24px, #b8b2a9 31px, transparent 31px, transparent 35px, #b8b2a9 35px);
					}

					&:after {
						content: '';
						position: absolute;
						top: 0;
						left: 0;
						height: 100%;
						width: 1px;
						background-image: -owg-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
						background-image: -webkit-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
						background-image: -moz-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
						background-image: -o-linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
						background-image: linear-gradient(to top, transparent 8px, #b8b2a9 8px, #b8b2a9 14px, transparent 14px, transparent 19px, #b8b2a9 19px, #b8b2a9 25px, transparent 25px, transparent 30px, #b8b2a9 30px, #b8b2a9 36px, transparent 36px);
					}

					&:hover:before, &.hover:before {
						background-image: -owg-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
						background-image: -webkit-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
						background-image: -moz-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
						background-image: -o-linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
						background-image: linear-gradient(to top, #9a7641 9px, transparent 9px, transparent 13px, #9a7641 13px, #9a7641 20px, transparent 20px, transparent 24px, #9a7641 24px, #9a7641 31px, transparent 31px, transparent 35px, #9a7641 35px);
					}

					&:hover:after, &.hover:after {
						background-image: -owg-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
						background-image: -webkit-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
						background-image: -moz-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
						background-image: -o-linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
						background-image: linear-gradient(to top, transparent 8px, #9a7641 8px, #9a7641 14px, transparent 14px, transparent 19px, #9a7641 19px, #9a7641 25px, transparent 25px, transparent 30px, #9a7641 30px, #9a7641 36px, transparent 36px);
					}
				}
			}
		}

		.buildQueueContainer {
			position: absolute;
			top: 0;
			right: 0;
			margin: 0 1px;
			height: 100%;
			width: 198px;
			padding-left: 10px;
			border-left: 1px solid #9a7641;
			background-image: -owg-linear-gradient(to right, #ebebeb, transparent 40%, transparent);
			background-image: -webkit-linear-gradient(to right, #ebebeb, transparent 40%, transparent);
			background-image: -moz-linear-gradient(to right, #ebebeb, transparent 40%, transparent);
			background-image: -o-linear-gradient(to right, #ebebeb, transparent 40%, transparent);
			background-image: linear-gradient(to right, #ebebeb, transparent 40%, transparent);

			&:before {
				content: '';
				position: absolute;
				top: 17px;
				left: -11px;
				height: 21px;
				width: 21px;
				background-color: #ebebeb;
				border-bottom: 1px solid #9a7641;
				border-left: 1px solid #9a7641;
				-webkit-transform: rotate(45deg) skew(12deg, 12deg);
				-moz-transform: rotate(45deg) skew(12deg, 12deg);
				-ms-transform: rotate(45deg) skew(12deg, 12deg);
				-o-transform: rotate(45deg) skew(12deg, 12deg);
				transform: rotate(45deg) skew(12deg, 12deg);
			}

			.buildingQueueSlot {
				float: left;
				margin: 5px 2px;
			}

			.feature_buildqueue_small_flat_black {
				filter: alpha(opacity = 40);
				opacity: 0.4;
			}
		}

		/*.buildingSlotImage {
			top: 6px;
		}*/
	}

	.destructionQueueContainer {
		position: absolute;
		bottom: 0;
		left: -58px;
		height: 45px;
		padding: 5px;
	}

	.detailsView {
		position: absolute;
		bottom: 59px;
		left: -58px;
		width: 335px;
		z-index: 3000;

		&:before {
			content: '';
			position: absolute;
			bottom: -20px;
			left: 0;
			height: 20px;
			width: 100%;
		}

		.detailsInnerBox {
			margin: 5px;
			border: 1px solid #b8b2a9;
			background-color: #fff;
			text-align: left;

			.detailsRow {
				position: relative;
				margin: 0 7px;
				padding: 3px 0;

				&.paid .costs {
					color: #b2b2b2;

					span.notEnough {
						color: #b2b2b2;
					}

					.enoughResTime {
						display: none;
					}
				}

				&:not(:last-child) {
					border-bottom: 1px solid #b8b2a9;
				}

				.detailsImageContainer {
					position: relative;
					display: inline-block;
					width: 53px;
					border-right: 1px solid #b8b2a9;

					.feature_buildqueue_small_flat_black {
						filter: alpha(opacity = 40);
						opacity: 0.4;
					}
				}
			}

			.detailsHeader {
				height: 28px;

				.detailsImageContainer {
					padding-top: 3px;
					text-align: center;

					i.headerIcon {
						left: -0.5px;
						vertical-align: middle;
					}
				}

				.headerText {
					display: inline-block;
					line-height: 28px;
					height: 28px;
					padding-left: 6px;
					font-weight: bold;
				}
			}

			.detailsContent {
				.subContainer {
					display: inline-block;
					position: relative;
					width: 53px;
					height: 74px;
					vertical-align: top;

					.feature_buildingqueue_slot_village_medium_flat_black, .feature_buildingqueue_slot_fields_medium_flat_black, .feature_buildingqueue_slot_combine_medium_flat_black {
						filter: alpha(opacity = 40);
						opacity: 0.4;
					}
				}

				.detailsImageContainer {
					.buildingQueueSlot {
						margin: 13px 3px;
					}

					.buildingSlotImage {
						position: absolute;
						top: 12px;
						left: 3px;
					}

					.cancelBuilding {
						position: absolute;
						top: 1px;
						right: 3px;
						background-color: #fff;
						border: 3px solid #fff;
						-webkit-border-radius: 50%;
						-moz-border-radius: 50%;
						-ms-border-radius: 50%;
						-o-border-radius: 50%;
						border-radius: 50%;
						-webkit-box-shadow: 0 0 0 1px #b8b2a9;
						-moz-box-shadow: 0 0 0 1px #b8b2a9;
						box-shadow: 0 0 0 1px #b8b2a9;
						
						background-image: url("https://iwstatic.g.bsrv.su/img/sprites/general.png");
						background-position: -96px -210px;
						width: 10px;
						height: 10px;

						&:hover:not(.disabled) {
							background-color: #e8e5e1;
							border: 3px solid #e8e5e1;
							-webkit-box-shadow: 0 0 0 1px #888;
							-moz-box-shadow: 0 0 0 1px #888;
							box-shadow: 0 0 0 1px #888;
							
							background-position: -364px -300px;
						}
					}

					.queueIcon {
						margin: 10px;

						&.builderIcon {
							margin-left: 14px;
						}
					}
				}

				.detailsInfo {
					width: 183px;
					padding: 2px 5px;
					box-sizing: border-box;

					.levelText {
						white-space: nowrap;

						i {
							top: -3px;
							opacity: 0.5;
						}
					}

					.detailsTime {
						position: absolute;
						bottom: 1px;
						left: 5px;
					}
				}

				.detailsButtonContainer {
					width: 48px;
					height: 74px;
					border-left: 1px solid #b8b2a9;

					button {
						width: 38px;
						height: 38px;
						margin: 16px 8px;
						overflow: visible;

						.content {
							padding: 0;

							.price {
								position: absolute;
								top: -12px;
								left: 22px;
							}
						}

						&:not(.disabled) i.disabled {
							cursor: pointer;
						}
					}

					i.voucher {
						position: absolute;
						top: 15px;
						left: 33px;
						pointer-events: none;
					}
				}

				.progressbar, .emptyBar {
					position: absolute;
					top: 62px;
					left: 0;
				}

				.progressbar .progress {
					width: 232px;
					height: 6px;
				}

				.emptyBar {
					width: 232px;
					height: 6px;
					background-color: #e8e5e1;
					border: 1px solid #b8b2a9;
				}
			}

			.costs .resource {
				border: 0;
				min-width: 62px;
				padding: 4px;

				i {
					margin: 0;
				}
			}

			.slotStatus {
				font-style: italic;

				&:not(:first-child) {
					margin-top: 2px;
				}
			}

			.impediment {
				color: #d40000;
			}

			&:before {
				content: '';
				position: absolute;
				bottom: -4px;
				left: 74px;
				width: 22px;
				height: 10px;
				border-left: 1px solid #b8b2a9;
				border-right: 1px solid #b8b2a9;
				background-color: #fff;
			}

			&:after {
				content: '';
				position: absolute;
				bottom: -11px;
				left: 79px;
				width: 13px;
				height: 13px;
				border-bottom: 1px solid #b8b2a9;
				border-left: 1px solid #b8b2a9;
				-webkit-transform: rotate(315deg) skew(16deg, 16deg);
				-moz-transform: rotate(315deg) skew(16deg, 16deg);
				-ms-transform: rotate(315deg) skew(16deg, 16deg);
				-o-transform: rotate(315deg) skew(16deg, 16deg);
				transform: rotate(315deg) skew(16deg, 16deg);
				background-color: #fff;
			}
		}

		&.queueType2 {
			&.slot1 .detailsInnerBox {
				&:before {
					left: 149px;
				}

				&:after {
					left: 154px;
				}
			}

			&.slot2 .detailsInnerBox {
				&:before {
					left: 198px;
				}

				&:after {
					left: 203px;
				}
			}

			&.slot3 .detailsInnerBox {
				&:before {
					left: 246px;
				}

				&:after {
					left: 251px;
				}
			}

			&.slot4 .detailsInnerBox {
				&:before {
					left: 295px;
				}

				&:after {
					left: 300px;
				}
			}
		}

		&:not(.queueType2) .detailsContent {
			height: 74px;

			.detailsImageContainer, .detailsInfo {
				height: 54px;
			}
		}

		&.queueType3 {
			.detailsInnerBox {
				&:before {
					left: 16px;
				}

				&:after {
					left: 21px;
				}
			}
		}
	}
}

.buildingSlotImage {
	position: absolute;
	top: 0;
	-webkit-transition: left .2s ease;
	-moz-transition: left .2s ease;
	-o-transition: left .2s ease;
	transition: left 0.2s ease;

	/*&.queueType1 {
		left: 0;
	}*/
	
	&.queueType2 {
		&.slot1 {
			transition-delay: 0;
			z-index: 1;
		}

		&.slot2 {
			transition-delay: .05s;
			z-index: 2;
		}

		&.slot3 {
			transition-delay: .1s;
			z-index: 3;
		}

		&.slot4 {
			transition-delay: .15s;
			z-index: 4;
		}

		&:not(.paid) .levelBubble {
			border: 1px solid #9a7641;
			-webkit-box-shadow: inset 0 0 0 2px #f6d81f,0 0 1px 0 #000;
			-moz-box-shadow: inset 0 0 0 2px #f6d81f,0 0 1px 0 #000;
			box-shadow: inset 0 0 0 2px #f6d81f, 0 0 1px 0 #000;

			&.enoughResources {
				-webkit-box-shadow: inset 0 0 0 2px #a5c400,0 0 1px 0 #000;
				-moz-box-shadow: inset 0 0 0 2px #a5c400,0 0 1px 0 #000;
				box-shadow: inset 0 0 0 2px #a5c400, 0 0 1px 0 #000;
			}
		}
	}

	.levelBubble {
		width: 18px;
		height: 18px;
		line-height: 18px;
		margin: -5px;
		background: rgba(255, 255, 255, 0.8);
		border: 1px solid #b8b2a9;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		-ms-border-radius: 50%;
		-o-border-radius: 50%;
		border-radius: 50%;
		font-size: 0.76923rem;
	}
}

.buildingQueueSlot.entityBox {
	position: relative;
	width: 43px;
	height: 43px;
	background-color: rgba(255, 255, 255, 0.6);
	border: 1px solid #b8b2a9;
	text-align: center;

	&:hover {
		&:not(.active):not(:active):not(.dummy):not(.disabled):not(.premiumItem):not(.noClick), &:active.noActive {
			border: 1px solid #b8b2a9;
		}
	}

	&.hover {
		&:not(.active):not(:active):not(.dummy):not(.disabled):not(.premiumItem):not(.noClick), &:active.noActive {
			border: 1px solid #b8b2a9;
		}
	}
	
	.progressbar {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 1;

		.progress {
			height: 6px;
			width: 100%;
			margin: -1px;
		}
	}

	&.paid {
		background-image: -owg-linear-gradient(to top, #a5c400, #fff 60%);
		background-image: -webkit-linear-gradient(to top, #a5c400, #fff 60%);
		background-image: -moz-linear-gradient(to top, #a5c400, #fff 60%);
		background-image: -o-linear-gradient(to top, #a5c400, #fff 60%);
		background-image: linear-gradient(to top, #a5c400, #fff 60%);

		&:hover {
			&:not(.active):not(:active):not(.dummy):not(.disabled):not(.premiumItem):not(.noClick), &:active.noActive {
				background-image: -owg-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -webkit-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -moz-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -o-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: linear-gradient(to top, #bfd94d, #fff 60%);
			}
		}

		&.hover {
			&:not(.active):not(:active):not(.dummy):not(.disabled):not(.premiumItem):not(.noClick), &:active.noActive {
				background-image: -owg-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -webkit-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -moz-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: -o-linear-gradient(to top, #bfd94d, #fff 60%);
				background-image: linear-gradient(to top, #bfd94d, #fff 60%);
			}
		}
	}

	&.locked {
		&:not(:hover):not(.hover), &.noClick {
			background-color: rgba(218, 216, 213, 0.5);
		}

		i {
			filter: alpha(opacity = 50);
			opacity: 0.5;
		}
	}

	&.empty:not(.locked):not(:hover):not(.hover), &.noClick:not(.locked) {
		border: 0;
		padding: 1px;
	}

	&.empty:not(.locked):not(:hover):not(.hover) .topLeftBorder:before, &.noClick:not(.locked) .topLeftBorder:before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 1px;
		width: 100%;
		background-image: -owg-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -webkit-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -moz-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -o-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-position: 7px 0;
		background-size: 21px 1px;
		background-repeat: repeat-x;
	}

	&.empty:not(.locked):not(:hover):not(.hover) .topLeftBorder:after, &.noClick:not(.locked) .topLeftBorder:after {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 1px;
		background-image: -owg-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -webkit-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -moz-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -o-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-position: 0 7px;
		background-size: 1px 21px;
		background-repeat: repeat-y;
	}

	&.empty:not(.locked):not(:hover):not(.hover) .bottomRightBorder:before, &.noClick:not(.locked) .bottomRightBorder:before {
		content: '';
		position: absolute;
		bottom: 0;
		right: 0;
		height: 1px;
		width: 100%;
		background-image: -owg-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -webkit-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -moz-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -o-linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-image: linear-gradient(right, #b8b2a9 11px, transparent 11px, transparent);
		background-position: 7px 0;
		background-size: 21px 1px;
		background-repeat: repeat-x;
	}

	&.empty:not(.locked):not(:hover):not(.hover) .bottomRightBorder:after, &.noClick:not(.locked) .bottomRightBorder:after {
		content: '';
		position: absolute;
		bottom: 0;
		right: 0;
		height: 100%;
		width: 1px;
		background-image: -owg-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -webkit-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -moz-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: -o-linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-image: linear-gradient(bottom, #b8b2a9 11px, transparent 11px, transparent);
		background-position: 0 7px;
		background-size: 1px 21px;
		background-repeat: repeat-y;
	}

	i.slotIcon {
		position: relative;
		top: 12px;
		vertical-align: middle;

		&.feature_buildingqueue_slot_combine_medium_flat_black {
			filter: alpha(opacity = 40);
			opacity: .4;
			top: 6px;
		}
	}
}

.tooltip .cancelBuildingTooltip {
	text-align: center;
}
</style>

<script>
import lib from '@/lib';

import Player from '@/classes/game/Player';
import BuildingQueue from '@/classes/game/BuildingQueue';

import BuildingQueueDetails from '@/components/partials/BuildingQueueDetails';

export default {
	mixins: lib.mixins,
	data: () => ({
		BuildingQueue,
		Player,
		
		intervalId: null,
	}),
	computed: {
		slotImages() {
			let data = [];
			for (const [type, qs] of Object.entries(this.gameModel.buildingQueue.queues)) {
				if (type != BuildingQueue.TYPE_DESTRUCTION) {
					for (const q of qs) {
						data.push(q);
					}
				}
			}
			return data;
		},
	},
	methods: {
		range: lib.range,
		
		buildPercentage(queueType) {
			const queues = this.gameModel.buildingQueue.queues[queueType];
			if (queues.length <= 0) return 0;
			
			const selData = queues[0];
			
			// Текущее время в формате Unix timestamp
			const currentTime = Math.floor(this.gameModel.currentServerTime / 1000);

			// Рассчитываем конечное время
			const startTime = selData.timeFinish - selData.duration;

			// Рассчитываем оставшееся время
			const elapsedTime = currentTime - startTime;
			
			return Math.min((elapsedTime / selData.duration) * 100, 100);
		},
		
		onHideDetails() {//mouseout
			this.intervalId = setTimeout(() => {
				this.gameModel.buildingQueue.activeSlot.slotHover = null;
				this.gameModel.buildingQueue.activeSlot.slot = null;
			}, 100);
		},
		onShowDetails(queueType, slot = null) {//mouseover
			clearTimeout(this.intervalId);
			this.gameModel.buildingQueue.activeSlot.slotHover = queueType;
			this.gameModel.buildingQueue.activeSlot.slot = slot;
		},
	},
	components: {
		BuildingQueueDetails,
	},
}
</script>